<template>
	<div class="view-index-h" v-if="mediaLength" :style="{'--img-count': mediaLength}">
		<div class="rotation-poster">
			<div class="container" :style="{top: swiper.offset, transition: `${swiper.ition}s`}">
				<template v-for="(item, idx) in settingData.mediaLst">
					<div class="inline-start img-item" v-if="item.videoUrl" :key="idx" @click="onPosterClick(item)"
						:style="{backgroundImage: 'url('+item.coverUrl+')'}">
						<video :id="`poster-video-player${idx}`" muted :autoplay="false"
							class="fade-in" :class="{'active': item.loaded}"
							@ended="onVideoEnded(idx)" @loadedmetadata="onloadedmetadata(idx)">
							<source :src="item.videoUrl" type="video/mp4" />
						</video>
					</div>
					<img class="img-item" v-else :src="item.coverUrl" :key="idx" alt="" @click="onPosterClick(item)">
				</template>
			</div>
			<div class="menu-list">
				<div class="menu-item single-line" v-for="(item, idx) in settingData.mediaLst" :key="idx"
					:class="{'actived': swiper.imgShow == idx}" @click="onclickMenuClick(idx)"
					:style="{top: (72 * idx) + 'px' }">
					{{item.linkTxt}}
				</div>
				<img class="menu-item-bg" src="~@/assets/left-menu-bg.png" :style="itemBgStyle" />
			</div>
			<search-bar />
		</div>
		<div class="product-list">
			<div class="inline-start product-caption">
				<img class="list-icon" src="~@/assets/list-icon.png" />
				<div class="inline-column caption">
					<span class="zh">产品与服务</span>
					<span class="en">PRODUCTS AND SERVICES</span>
				</div>
			</div>
			<div class="inline-between main-containner">
				<div class="left">
					<div class="menu-list">
						<img class="menu-item-bg" src="~@/assets/product-left-menu-bg.png" :style="productCatBgStyle" />
						<div class="menu-item single-line" v-for="(item, idx) in productCatLst" :key="idx"
							:style="{top: (6 + (46 + 12) * idx)+'px'}" @click="productCatIdx = idx">
							{{item.categoryName}}
						</div>
					</div>
				</div>
				<div class="inline-between right" v-if="curProductCat">
					<div class="product-item" v-for="(item, idx) in curProductCat.productServiceList" :key="idx"
						v-if="idx<2" @click="onProductItemClick(item.id)">
						<img :src="item.coverImgUrl" class="product-img" />
						<div class="inf-container">
							<div class="name single-line">{{item.productName}}</div>
							<div class="profile single-line">{{item.productProfile}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content-wrapper" v-if="subBrandSettingData">
			<div class="auto-height">
				<div class="sub-brand-content calc-line" v-html="subBrandSettingData"></div>
			</div>
		</div>
		<copy-right />
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	import SearchBar from '@/components/searchBar';
	import CopyRight from '@/components/copyRight';
	export default {
		name: 'IndexH',
		mixins: [IndexMixin],
		components: {
			SearchBar,
			CopyRight
		},
		data() {
			return {

			}
		},
		computed: {
			itemBgStyle() {
				return {
					top: (72 * this.swiper.imgShow) + 'px'
				}
			},
			productCatBgStyle() {
				return {
					top: ((46 + 12) * this.productCatIdx + 6) + 'px'
				}
			}
		},
		mounted() {
			//计算轮播图右侧宽度
			this.$nextTick(() => {
				const dom = document.querySelector('.rotation-poster .menu-list');
				if (dom) {
					const rect = dom.getBoundingClientRect();
					dom.style.width = (rect.height / this.scaleRate) + 'px';
				}
			});
		},
		methods: {

		}
	}
</script>

<style scoped lang="less">
	.view-index-h {
		width: 100%;
		padding-left: calc(75px * var(--scale-rate));

		.rotation-poster {
			width: 100%;
			height: 0;
			padding-top: 36%;
			position: relative;
			overflow: hidden;

			.container {
				width: 100%;
				height: calc(100% * var(--img-count));
				top: 0;
				overflow: hidden;
				position: absolute;
				/* 开启弹性盒，让图片横向排列 */
				display: flex;
				flex-direction: column;
				animation: run 10s ease infinite;
			}

			.img-item {
				width: 100%;
				height: calc(100% / var(--img-count));
				cursor: pointer;

				video {
					width: 64%;
					height: 100%;

					&.fade-in {
						opacity: 0;
						transition: opacity 1s ease-in-out;
					}

					&.fade-in.active {
						opacity: 1;
					}
				}
			}

			div .img-item {
				background-size: cover;
				background-color: #000000;
			}


			.menu-list {
				position: absolute;
				z-index: 99;
				right: 0;
				top: 0;
				width: calc(36% / var(--scale-rate));
				height: calc(100% / var(--scale-rate));
				background-color: rgba(230, 230, 230, 31%);
				overflow-y: auto;
				transform: scale(var(--scale-rate));
				transform-origin: 100% 0;
				backdrop-filter: blur(3px);

				&::-webkit-scrollbar {
					display: none;
				}

				.menu-item {
					position: absolute;
					cursor: pointer;
					line-height: 72px;
					width: calc(100% - 40px);
					height: 72px;
					margin: auto 20px;
					font-size: 20px;
					color: rgba(255, 255, 255, 1);
					font-weight: lighter;
					z-index: 99;
					text-shadow:1px 1px 1px rgba(0, 0, 0, 0.8);

					&.actived {
						font-weight: normal;
						text-shadow:1px 1px 1px rgba(0, 0, 0, 1);
					}
				}

				.menu-item-bg {
					width: 100%;
					height: 72px;
					object-fit: fill;
					position: absolute;
					z-index: 0;
					transition: 0.2s;
					z-index: 0;
				}
			}

			.search-bar {
				position: absolute;
				top: 0;
				left: calc(5px * var(--scale-rate));
				z-index: 999;
			}
		}

		.product-list {
			.product-caption {
				height: calc(125px * var(--scale-rate));

				.list-icon {
					width: calc(28px * var(--scale-rate));
					height: calc(29px * var(--scale-rate));
					margin-left: calc(7px * var(--scale-rate));
				}

				.caption {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: flex-start;
					margin-left: 14px;
					//margin-top: 10px;
					line-height: 1;
					transform: scale(var(--scale-rate));
					transform-origin: left center;

					.zh {
						font-size: 24.87px;
						letter-spacing: 1.4px;
						font-weight: bold;
					}

					.en {
						font-size: 10.26px;
						letter-spacing: -0.8px;
						margin-top: 2px;
						margin-left: 20px;
					}
				}
			}

			.main-containner {
				div {
					//border: 1px solid #000000;
				}

				width: 100%;
				//height: calc(234px * var(--scale-rate));
				height: calc(351px * var(--scale-rate));

				.left {
					width: calc(221px * var(--scale-rate));
					height: 100%;
					overflow-y: auto;

					&::-webkit-scrollbar {
						display: none;
					}

					.menu-list {
						width: 221px;
						//margin-left: -20px;
						height: calc(100% / var(--scale-rate));
						position: relative;
						transform: scale(var(--scale-rate));
						transform-origin: 0 0;
					}


					.menu-item-bg {
						width: 221px;
						height: 46px;
						object-fit: fill;
						position: absolute;
						z-index: 0;
						transition: 0.2s;
					}

					.menu-item {
						cursor: pointer;
						position: absolute;
						width: 221px;
						height: 46px;
						padding-left: 60px;
						z-index: 10;
						line-height: 46px;
						font-size: 21px;
						letter-spacing: 2px;
					}
				}

				.right {
					flex: 1;
					height: 100%;
					//padding: 0 calc(100px * var(--scale-rate));
					padding-left: calc(50px * var(--scale-rate));

					.product-item {
						//width: calc(351px * var(--scale-rate));
						//height: calc(234px * var(--scale-rate));
						width: calc(421px * var(--scale-rate));
						height: calc(289px * var(--scale-rate));
						position: relative;
						cursor: pointer;

						.product-img {
							width: 100%;
							height: 100%;
							object-fit: fill;
						}

						.inf-container {
							width: calc(100% / var(--scale-rate));
							height: 68px;
							background-color: rgba(58, 58, 61, 0.58);
							position: absolute;
							bottom: calc(8px * var(--scale-rate));
							color: #FFFFFF;
							transform: scale(var(--scale-rate));
							transform-origin: 0 100%;
							padding-left: 20px;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: flex-start;

							.name {
								font-size: 20px;
								width: 100%;
							}

							.profile {
								font-size: 12px;
								width: 100%;
							}
						}
					}
				}
			}

		}

		.sub-brand-content {
			margin-top: 50px;
			width: calc(100% / var(--scale-rate));
			font-size: 24px;
			color: rgb(35, 35, 35);
			transform: scale(var(--scale-rate));
			transform-origin: left top;
		}

	}
</style>